<script setup>
import { onMounted, ref } from 'vue'
import { initLocalizationStoreAsync } from '@/stores/localizations.store'
import { useWebSiteStore } from './stores/website.store'

const loading = ref(true)
const websiteStore = useWebSiteStore()

onMounted(async() => {
  try {
    if (websiteStore.isLogged()) {
      await websiteStore.refreshTokenAsync(true)
      await websiteStore.fetchUserData()
    }
  } catch {
    await websiteStore.logoutAsync(false)
  } finally {
    await initLocalizationStoreAsync(websiteStore.userData?.default_language)
    loading.value = false
  }
})
</script>

<template>
  <div
    v-if="loading"
    class="loading-container"
  >
    <q-spinner
      color="primary"
      size="3em"
    />
  </div>
  <router-view v-else />
</template>

<style>
#app {
  font-family: 'Outfit', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
}
</style>
